/**
 * @generated SignedSource<<5f28d4c031f39f345d5fb96acd162493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateFileInput = {
  ids?: ReadonlyArray<string | null> | null;
  name?: string | null;
  taskId?: string | null;
  projectId?: string | null;
  folderId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateFileMutationModernMutation$variables = {
  input: UpdateFileInput;
};
export type updateFileMutationModernMutation$data = {
  readonly updateFile: {
    readonly files: ReadonlyArray<{
      readonly name: string | null;
      readonly folder: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly task: {
        readonly id: string;
        readonly name: string | null;
        readonly companyTaskId: number | null;
      } | null;
    } | null> | null;
  } | null;
};
export type updateFileMutationModernMutation = {
  variables: updateFileMutationModernMutation$variables;
  response: updateFileMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Folder",
  "kind": "LinkedField",
  "name": "folder",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyTaskId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateFileMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFilePayload",
        "kind": "LinkedField",
        "name": "updateFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateFileMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFilePayload",
        "kind": "LinkedField",
        "name": "updateFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "84ddb9532cf1c662647f95eb6c9820a6",
    "id": null,
    "metadata": {},
    "name": "updateFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateFileMutationModernMutation(\n  $input: UpdateFileInput!\n) {\n  updateFile(input: $input) {\n    files {\n      name\n      folder {\n        id\n        name\n      }\n      task {\n        id\n        name\n        companyTaskId\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b34ae75bdc3c8c03a0106f3b927f7fa";

export default node;
